import { ActivitiesDefaultLimit, type ActivitiesResponseMeta } from '../types';

export const resolveHasMore = (
  meta: ActivitiesResponseMeta | undefined,
  activitiesCount: number,
  limit: number | undefined,
): boolean => {
  if (typeof meta?.hasMore === 'boolean') {
    return meta.hasMore;
  }
  return activitiesCount >= (limit ?? ActivitiesDefaultLimit);
};
